export const IFRAME_REG_EXP = /^<iframe.+iframe>$/;

export const CASUAL = 'CASUAL';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const TARIFF = 'TARIFF';
export const PURCHASE_BILL = 'PURCHASE_BILL';
export const TICKET = 'TICKET';
export const TIPS = 'TIPS';

export const ONCE = 'ONCE';
export const DAILY = 'DAILY';
export const WEEKLY = 'WEEKLY';
export const MONTHLY = 'MONTHLY';
export const SEMI_ANNUALLY = 'SEMI-ANNUALLY';
export const ANNUALLY = 'ANNUALLY';
export const SELECTIVELY = 'SELECTIVELY';

export const WRITE_OFF_OPTIONS_TEXT = {
  [DAILY]: 'common.daily',
  [WEEKLY]: 'common.weekly',
  [MONTHLY]: 'common.monthly',
  [SEMI_ANNUALLY]: 'common.semi-annually',
  [ANNUALLY]: 'common.annually',
  [SELECTIVELY]: 'can.choose.period',
};

export const CREATED = 'CREATED';
export const DECLINE = 'DECLINE';
export const PARTNER_PAYOUT_ACCRUAL = 'PARTNER_PAYOUT_ACCRUAL';

export const CARD_ICON_TYPE = {
  'TRANSFER': 'transfer',
  'PAYOUT': 'withdrawal',
  'PURCHASE': 'transfer',
  'SERVICE_DEBIT_MERCHANT': 'transfer',
  'CASUAL': 'bill',
  'SUBSCRIPTION': 'bill',
  'TARIFF': 'bill',
  [PURCHASE_BILL]: 'transfer',
  'REFUND': 'refund',
  'CONFIRM_CARD': 'transfer',
  'REFUND_DEBIT': 'transfer',
  [PARTNER_PAYOUT_ACCRUAL]: 'partner',
  'TICKET': 'ticket',
  'TIPS': 'tips',
};
